import React, { useEffect, useState } from 'react';
import pkg from '../package.json';
import buildInfo from './buildInfo.json';
import { BASE_URL } from './services/ApiService/ApiConfig';

const fmt = (iso) => {
    if (!iso || iso === 'pendiente-de-build') return iso || '—';
    try {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return iso;
        return d.toLocaleString();
    } catch (e) {
        return iso;
    }
};

const AppFooter = () => {
    const year = new Date().getFullYear();
    const [back, setBack] = useState(null);

    // Consulta la version del backend (endpoint publico /version). Sirve para
    // saber que jar esta realmente desplegado (no solo el front).
    useEffect(() => {
        let activo = true;
        fetch(`${BASE_URL}/version`)
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => { if (activo) setBack(data); })
            .catch(() => { if (activo) setBack(null); });
        return () => {
            activo = false;
        };
    }, []);

    return (
        <div className="layout-footer flex flex-column align-items-center justify-content-center p-3 shadow-2 gap-2">
            <img
                id="footer-logo"
                src="assets/layout/images/Logo_Cema_Redondo.png"
                alt="CEMA"
                style={{ height: 48, width: 'auto' }}
            />
            <div className="text-sm text-center" style={{ color: '#555' }}>
                Disenado por{' '}
                <a href="https://soriseg.com.ec/" target="_blank" rel="noopener noreferrer">
                    Soriseg
                </a>
                {' · '}
                Desarrollado por{' '}
                <a href="https://apexlict.com/" target="_blank" rel="noopener noreferrer">
                    Apexlict
                </a>
            </div>
            <div className="text-xs opacity-70 text-center" style={{ color: '#777' }}>
                {`© ${year} Soriseg · v${pkg.version}`}
            </div>
            <div className="text-xs text-center" style={{ color: '#999' }}>
                {`Front: v${buildInfo.version} · ${fmt(buildInfo.buildTime)} · ${buildInfo.commit}`}
                {back && ` · Back: v${back.version} · ${fmt(back.buildTime)}`}
            </div>
        </div>
    );
};

export default AppFooter;
